import { Component, Vue } from 'vue-property-decorator';
import WithRender from './companyuser.html';
import config from '@/settings/config.js';
import _axios from '@/services/axios';
import Loading from 'vue-loading-overlay';


@WithRender
@Component({
  components: {
    Loading
  }
})
export default class CompanyUser extends Vue {
  isLoading = false;
  form = {
    fullName: '',
    email: ''
  }

  onSubmit(event: any) {
    event.preventDefault()
    if (this.form.fullName.trim() == '') {
      this.ErrorNotification('Please enter full name', 'danger');
      return;
    }
    if (this.form.email.trim() == '') {
      this.ErrorNotification('Please enter email address', 'danger');
      return;
    }

    this.isLoading = true;

    _axios.post(config.gateway + "customerdata/CompanyUser/registerCompanyUser", this.form)
      .then((response) => {
        this.ErrorNotification('User has been successfully added', 'success');
      })
      .catch((error) => {
        const err = error as any;
        if (err.response && err.response.status && err.response.status == '400')
          this.ErrorNotification(err.response.data, 'danger');
        else
          this.ErrorNotification("please check that you have data or your internet connection is on.", 'danger');
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private ErrorNotification(message: string, type: string) {
    this.$bvToast.toast(message, {
      title: 'Notification',
      variant: type,
      autoHideDelay: 5000,
    });
  }
}
